import { AppBar } from "Components/NavBar/Navbar";
import { Sidebar } from "Components/SideBar/Sidebar";
import {
  ToastContextDispatch,
  UserInfoContext,
  SuccessfullyMessageBarContext,
  UserInfoContextDispatch,
  VersionUpdateMessageBarDispatch,
  VersionUpdateMessageBarContext,
} from "Context/CommonContext";
import routes, { dynamicRoutes } from "Layout/routes";
import { useContext, useEffect, useState } from "react";
import { Navigate, Route, useOutlet } from "react-router-dom";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import {
  BASE_URL,
  FETCH_REGION,
  GET_ACAD_YEAR,
  GET_BOARD,
  GET_BRANCH,
  GET_CLASS,
  GET_STREAMS,
  GET_SUBJECTS,
  GET_USER_INFO,
  GET_TEST_TYPE,
  GET_PHASE,
  GET_STATE,
  FETCH_LOP_REGIONS,
  GET_EXAM,
  GET_UNREAD_COMMENTS,
} from "utilFunctions/Constants/urlConstants";
import { useAuth } from "utilFunctions/CustomHooks/useAuth";
import SuccessfullyMessageBar from "Layout/SuccessfullyMessageBar";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import useMasterContext from "Context/MasterContext";
import { mapToArrayForSelect } from "utilFunctions/helperFunctions/HelperFunction";
// import StudentprofileHome from "Pages/BranchHealth/Student/StudentProfileHome";
import { sendRefreshEventToGTAG } from "utilFunctions/helperFunctions/analytics";
import RequireAuth from "utilFunctions/RequireAuth";
import CustomModal from "Components/CommonComponents/CustomModal";
import Typography from "Components/CommonComponents/Typography";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { storeQuestionFilter } from "redux/action/questionAction";

// Extend the Window interface to include usetifulTags
declare global {
  interface Window {
    usetifulTags?: any;
  }
}

const ContainerDivAdmin = styled<any>("div")`
  padding-left: ${(props: any) => (props.width > 1200 ? "60px" : "0px")};
`;
const classUrl = BASE_URL + GET_CLASS;
const streamUrl = BASE_URL + GET_STREAMS;
const acadyearUrl = BASE_URL + GET_ACAD_YEAR;
const subjectUrl = BASE_URL + GET_SUBJECTS;
const phaseUrl = BASE_URL + GET_PHASE;
const branchUrl = BASE_URL + GET_BRANCH;
const stateUrl = BASE_URL + GET_STATE;
const boardUrl = BASE_URL + GET_BOARD;
const regionUrl = BASE_URL + FETCH_REGION;
const testTypeUrl = BASE_URL + GET_TEST_TYPE;
const examUrl = BASE_URL + GET_EXAM;

export const ProtectedLayout = () => {
  const [sidenavOpen, setSidenavOpen] = useState(false);
  // const { masters } = useMasterContext();

  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const userinfoDispatch = useContext<any>(UserInfoContextDispatch);
  const { saveMasterData } = useMasterContext();
  const successMessageInfor = useContext<any>(SuccessfullyMessageBarContext);
  const VersionUpdateDispatch = useContext<any>(
    VersionUpdateMessageBarDispatch
  );
  const versionUpdateNeeded = useContext<any>(VersionUpdateMessageBarContext);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const outlet = useOutlet();
  const { screen, windowSize }: any = useWindowSize();
  const { width } = windowSize;
  const { user, logout } = useAuth();
  const dispatch = useDispatch();
  const [isMiniSideBar, setIsMiniSideBar] = useState<boolean>(false);
  const [showNotification, setShowNotification] = useState(false);
  const IsVersionUpdateNeeded = localStorage.getItem("version-update-needed");
  useEffect(() => {
    const itemKey = "insightObject";
    const lastVisitKey = "lastVisitDate";

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const lastVisitDateString = localStorage.getItem(lastVisitKey);
    let lastVisitDate: Date | null = null;

    if (lastVisitDateString) {
      lastVisitDate = new Date(lastVisitDateString);
    }
    if (lastVisitDate && lastVisitDate < today) {
      localStorage.removeItem(itemKey);
    }

    localStorage.setItem(lastVisitKey, today.toString());
  }, []);
  useEffect(() => {
    getuserInfo(userInfo);
  }, []);

  useEffect(() => {
    if (userInfo?.id) {
      fetchLectureAssetAccess(userInfo);
    }
  }, [userInfo?.id]);
  useEffect(() => {
    if (IsVersionUpdateNeeded == "true") {
      VersionUpdateDispatch({
        isShow: true,
        message:
          "A new version of Aakash Guru is available. Click Update to start using the latest version.",
      });
    }
  }, [IsVersionUpdateNeeded]);
  useEffect(() => {
    if (window.location.hash.includes("#/admin/question")) {
      return;
    } else {
      dispatch(storeQuestionFilter());
    }
  }, [window.location.href]);
  useEffect(() => {
    if (window.usetifulTags && userInfo?.id) {
      window.usetifulTags = {
        userId: userInfo.id,
        firstName: userInfo?.user_name,
        lastName: userInfo?.email,
      };
    }
  }, [userInfo?.id]);

  useEffect(() => {
    getMasterData(streamUrl, "streams", {
      label: "stream",
      key: "id",
      value: "id",
    });
    getMasterData(classUrl, "classes", {
      label: "class",
      key: "id",
      value: "id",
    });
    getMasterData(acadyearUrl, "acadYears", {
      label: "session",
      key: "id",
      value: "id",
    });
    getMasterData(acadyearUrl, "userAcadYear", {
      label: "session",
      key: "id",
      value: "id",
    });
    getMasterData(subjectUrl, "subjects", {
      label: "subject",
      key: "id",
      value: "id",
    });
    getMasterData(branchUrl, "branches", {
      label: "branchName",
      key: "branchId",
      value: "id",
    });
    getMasterData(stateUrl, "states", {
      label: "state",
      key: "id",
      value: "id",
    });
    getMasterData(boardUrl, "boards", {
      label: "boardName",
      key: "id",
      value: "id",
    });
    getMasterData(regionUrl, "regions", {
      label: "region",
      key: "id",
      value: "id",
    });
    getMasterData(testTypeUrl, "testTypes", {
      label: "testType",
      key: "id",
      value: "id",
    });
    getMasterData(phaseUrl, "phases", {
      label: "phaseName",
      key: "phase",
      value: "id",
    });
    getMasterData(examUrl, "exams", {
      label: "examName",
      key: "id",
      value: "id",
    });
    getMasterData(BASE_URL + FETCH_LOP_REGIONS, "lopReasons", {
      label: "reason",
      key: "id",
      value: "id",
    });
    const facultyId = userInfo?.employeeId;
    const usersSubjects =
      userInfo?.subjectsListing?.map((subject: any) => subject.label) || [];
    const url =
      BASE_URL +
      GET_UNREAD_COMMENTS +
      "?facultyId=" +
      facultyId +
      "&subjects=" +
      ["General", ...usersSubjects]?.join(",");
    getMasterData(url, "unreadComments", {
      label: "unreadComment",
      key: "id",
      value: "id",
    });
  }, [userInfo?.id]);
  const userBranchArray: any =
    typeof userInfo?.branch === "string" && userInfo.branch.length > 0
      ? userInfo.branch.split(",").map(Number)
      : [];
  const getMasterData = async (url: string, key: string, object: any) => {
    const id = userInfo?.id;
    if (["classes", "subjects"].includes(key)) {
      const streamIdArray: any = JSON.parse(
        localStorage.getItem("idToStreamName") as any
      );
      const streamIds: any =
        streamIdArray && streamIdArray.map((item: any) => item.value);
      url = url + "?userStreamIds=" + streamIds;
    }
    if (id) {
      await getAPIRequest({
        url: url,
        success: (response: any) => {
          const data = response?.data?.data || [];
          const newArray: selectInterface[] = [];
          if (key == "classes") {
            data?.sort((a: any, b: any) =>
              a.class < b.class ? 1 : b.class < a.class ? -1 : 0
            );
          }
          data.map((ele: any) => {
            if (
              key == "streams" &&
              !["SOE", "SOM", "SOF"].includes(ele[object?.label])
            ) {
              return;
            } else if (key == "acadYears" && ele[object?.label] < "2023") {
              return;
            } else if (key == "regions") {
              newArray.push({
                label: ele["region"],
                regionCode: ele["regionCode"],
                key: ele["id"],
                id: ele["id"],
                value: ele["regionCode"],
                otherMapping: ele["stateIds"],
              });
            } else if (key == "lopReasons") {
              newArray.push({
                label: ele["reason"],
                key: ele["id"],
                id: ele["id"],
                value: ele["id"],
              });
            } else if (key == "subjects") {
              newArray.push({
                label: ele["subject"],
                key: ele["id"],
                value: ele["id"],
                otherMapping: ele["iconUrl"],
                id: ele["id"],
                streamIds: ele["streamIds"],
              });
            } else {
              newArray.push({
                label:
                  key == "branches"
                    ? ele[object?.label] + "-" + ele?.[object?.key]
                    : ele[object?.label],
                key: ele[object?.key],
                value:
                  key == "branches"
                    ? ele?.[object?.key] && ele?.[object?.key].slice(2) == ""
                      ? ele?.[object?.key]
                      : key == "branches" &&
                        ele?.[object?.key] &&
                        ele?.[object?.key].slice(2) != ""
                      ? ele?.[object?.key].slice(2)
                      : ele?.[object?.value]
                    : ele?.[object?.value],
                region: key == "branches" ? ele["region"] : "",
                regionCode: key == "branches" ? ele["regionCode"] : "",
                id: ele["id"],
                otherMapping: ele["stateId"] ? ele["stateId"] : "",
              });
            }
          });
          if (key == "branches") {
            const arr: any = [];
            [...data].forEach((ele: any) => {
              if (userBranchArray.includes(ele.id)) {
                arr.push({
                  label: ele["branchName"] + "-" + ele?.["branchId"],
                  value: ele?.["branchId"],
                  key: ele?.["branchId"],
                  id: ele?.["id"],
                  region: key == "branches" ? ele["region"] : "",
                  regionCode: key == "branches" ? ele["regionCode"] : "",
                  otherMapping: ele["stateId"] ? ele["stateId"] : "",
                });
              }
            });
            saveMasterData({ userAssignedBranches: arr });
          }
          if (key == "unreadComments") {
            saveMasterData({ [key]: data });
            return;
          }
          saveMasterData({ [key]: newArray });
        },
        failure: (err: any) => {
          console.error(err);
        },
      } as getRequestInterface);
    }
  };

  const getuserInfo = async (data: any) => {
    const url = BASE_URL + GET_USER_INFO;
    const id = data?.id;
    if (!id || id == null) {
      await getAPIRequest({
        url: url,
        success: (response: any) => {
          const data = response?.data?.data;
          const objforMapToSelect = {
            suggest: data,
            keyToSet: "idToStreamName",
            order: true,
          };
          const newSubjectArray = data?.subjects.map((ele: any) => {
            return { label: ele.subjectName, key: ele.id, value: ele.id };
          });
          const streamsArray = mapToArrayForSelect(objforMapToSelect);
          const newstreamsArray = streamsArray.filter(
            (item) =>
              item.label == "SOF" || item.label == "SOM" || item.label == "SOE"
          );
          userinfoDispatch({
            ...data,
            id: data?.id,
            facId: data?.id,
            user_name: data?.name,
            username: data?.username,
            email: data?.email,
            branch: data?.branch,
            department: data?.department,
            role: data?.role,
            class_id: data?.class_id,
            branchId: data?.branchId,
            branchName: data?.branchName,
            idToStreamName: data.idToStreamName,
            employeeId: data?.employeeId,
            subjects: data?.subjects,
            stateIds: data?.stateIds,
            subjectsListing: newSubjectArray,
            syllabusCompliance: true,
            userStreams:
              newstreamsArray && Array.isArray(newstreamsArray)
                ? newstreamsArray
                : [],
            fexRole: data?.fexRole,
            region: data?.region,
          } as IUserInfo);
          sendRefreshEventToGTAG(data?.email, data?.fexRole);
        },
        failure: (err: any) => {
          if (user) {
            logout();
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            ToastDispatch({
              isOpen: true,
              type: "Error",
              message: err?.message,
            });
          }
        },
      } as getRequestInterface);
    }
  };

  const fetchLectureAssetAccess = async (userInfo: any) => {
    const url = BASE_URL + "lectureAccess";
    await getAPIRequest({
      url: url,
      success: (response: any) => {
        const data = response?.data;
        userinfoDispatch({
          ...userInfo,
          lectureAssetAccess: data?.data,
        });
      },
      failure: (err: any) => {
        console.error(err);
      },
    } as getRequestInterface);
  };

  // // toggles collapse between mini sidenav and normal
  const toggleSidenav = () => {
    if (document.body.classList.contains("g-sidenav-hidden")) {
      document.body.classList.remove("g-sidenav-hidden");
      document.body.classList.add("g-sidenav-pinned");
      setSidenavOpen(true);
    } else {
      document.body.classList.add("g-sidenav-hidden");
      document.body.classList.remove("g-sidenav-pinned");
      setSidenavOpen(false);
    }
  };

  // const userAssignedBranches =
  //   masters?.userAssignedBranches?.map((el: any) => el.value).join(",") || "";
  // const currentUser = {
  //   user_name: userInfo?.user_name,
  //   user_email: userInfo?.email,
  //   employee_id: userInfo?.facId,
  //   branch: userAssignedBranches,
  //   region: userInfo.subjects?.map((el: any) => el.subjectName).join(",") || "",
  // };
  if (!user) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <div className="adminlayout">
        <Sidebar
          logo={{
            innerLink: "/",
            imgSrc: require("Assets/Images/aakashlogo.png"),
            imgAlt: "...",
          }}
          routes={routes}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          isMiniSideBar={isMiniSideBar}
          setIsMiniSideBar={setIsMiniSideBar}
          setIsNugget={() => {
            //setIsNugget(true);
          }}
        />
        <div className="d-flex flex-column">
          <AppBar
            toggleSidenav={toggleSidenav}
            isMiniSideBar={isMiniSideBar}
            setIsMiniSideBar={setIsMiniSideBar}
            showNotification={showNotification}
            setShowNotification={setShowNotification}
          />
          {versionUpdateNeeded.isShow ? (
            <CustomModal
              size="md"
              modal={versionUpdateNeeded.isShow}
              title={"Update Available"}
              toggle={() => {
                window.location.reload();
                localStorage.setItem("version-update-needed", "false");
                VersionUpdateDispatch({
                  isShow: false,
                  message: "",
                });
              }}
            >
              <div className="w-100 d-flex flex-column p-5 justify-content-center align-items-center gap-4">
                <Typography variant="h4" color="black">
                  {versionUpdateNeeded.message}
                </Typography>
                <Button
                  color="aeslPrimary"
                  onClick={() => {
                    window.location.reload();
                    localStorage.setItem("version-update-needed", "false");
                    VersionUpdateDispatch({
                      isShow: false,
                      message: "",
                    });
                  }}
                >
                  Update
                </Button>
              </div>
            </CustomModal>
          ) : null}
          {successMessageInfor.isShow ? (
            <SuccessfullyMessageBar message={successMessageInfor.message} />
          ) : null}
          <ContainerDivAdmin screen={screen} width={width}>
            {outlet}
          </ContainerDivAdmin>
        </div>
      </div>
      {/* {userInfo?.id &&
        accessToken != null &&
        (["xl", "lg", "xxl"].includes(screen) ? (
          <NuggetChatWidget
            accessToken={accessToken}
            module={module}
            userInfo={userInfo}
            commonPayload={{
              ...commonPayload,
              initiallyVisible: true,
              initiallyExpanded: false,
            }}
          />
        ) : (
          isNugget && (
            <NuggetChatWidget
              accessToken={accessToken}
              module={module}
              userInfo={userInfo}
              setIsNugget={setIsNugget}
              commonPayload={{
                ...commonPayload,
                alwaysHideBubble: false,
                initiallyVisible: true,
                initiallyExpanded: true,
              }}
            />
          )
        ))} */}
    </>
  );
};
export const AdminRoutes = (routes: any): JSX.Element => {
  return (
    <>
      {routes.map((item: any, index: number) => {
        return (
          <Route
            key={index}
            path={item.path}
            element={
              <RequireAuth userroles={item.access} item={item}>
                {item.component}
              </RequireAuth>
            }
          />
        );
      })}
      {dynamicRoutes.map((item: any, index: number) => {
        return (
          <Route
            key={index}
            path={item.path}
            element={
              <RequireAuth userroles={item.access} item={item}>
                {item.component}
              </RequireAuth>
            }
          />
        );
      })}
    </>
  );
};
